var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8056 1.25098H3.19444C2.67875 1.25098 2.18417 1.45584 1.81951 1.82049C1.45486 2.18515 1.25 2.67972 1.25 3.19542V7.08431C1.25 7.60001 1.45486 8.09459 1.81951 8.45924C2.18417 8.82389 2.67875 9.02875 3.19444 9.02875H16.8056C17.3213 9.02875 17.8158 8.82389 18.1805 8.45924C18.5451 8.09459 18.75 7.60001 18.75 7.08431V3.19542C18.75 2.67972 18.5451 2.18515 18.1805 1.82049C17.8158 1.45584 17.3213 1.25098 16.8056 1.25098ZM3.19444 7.08431V3.19542H16.8056V7.08431H3.19444Z",
    fill: "#8796AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02778 10.001H3.19444C2.67875 10.001 2.18417 10.2058 1.81951 10.5705C1.45486 10.9351 1.25 11.4297 1.25 11.9454V16.8065C1.25 17.3222 1.45486 17.8168 1.81951 18.1815C2.18417 18.5461 2.67875 18.751 3.19444 18.751H9.02778C9.54348 18.751 10.0381 18.5461 10.4027 18.1815C10.7674 17.8168 10.9722 17.3222 10.9722 16.8065V11.9454C10.9722 11.4297 10.7674 10.9351 10.4027 10.5705C10.0381 10.2058 9.54348 10.001 9.02778 10.001ZM3.19444 16.8065V11.9454H9.02778V16.8065H3.19444Z",
    fill: "#8796AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8064 10.001H13.8898C13.3741 10.001 12.8795 10.2058 12.5148 10.5705C12.1502 10.9351 11.9453 11.4297 11.9453 11.9454V16.8065C11.9453 17.3222 12.1502 17.8168 12.5148 18.1815C12.8795 18.5461 13.3741 18.751 13.8898 18.751H16.8064C17.3221 18.751 17.8167 18.5461 18.1814 18.1815C18.546 17.8168 18.7509 17.3222 18.7509 16.8065V11.9454C18.7509 11.4297 18.546 10.9351 18.1814 10.5705C17.8167 10.2058 17.3221 10.001 16.8064 10.001ZM13.8898 16.8065V11.9454H16.8064V16.8065H13.8898Z",
    fill: "#8796AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectTemplate);
export default __webpack_public_path__ + "static/media/selectTemplate.2d5eb5ddf6898c25f16149e418f79a85.svg";
export { ForwardRef as ReactComponent };